// src/components/ChatLauncher.jsx
export const openChatWindow = () => {
  // const url = "http://localhost:3000/virtual-agent"; // local dev route
  const url = "https://user.confidanto.com/virtual-agent"; // prod dev route
  const features =
    "width=400,height=640,top=100,left=100,resizable=yes,scrollbars=no,status=no";

  // open popup
  const newWindow = window.open(url, "VirtualAgent", features);

  if (newWindow) {
    newWindow.focus();
  }
};

export function ChatLauncher() {
  return (
    <button
      onClick={openChatWindow}
      className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
    >
      Open Virtual Agent Chat
    </button>
  );
}
